import { Navbar, Container } from 'react-bootstrap';
import Config from '../config/Config';
import BrandSection from './BrandSection';
import UserSection from './UserSection';

const MainNavbar = ({ toggleLanguage, currentLanguage}) => {
  const { navbarHeight } = Config.appearance;

  return (
    <Navbar style={{ height: navbarHeight }}>
      <Container className="d-flex justify-content-between align-items-center">
        {/* Brand Section */}
        <BrandSection />
        {/* User Section */}
        <UserSection toggleLanguage={toggleLanguage} currentLanguage={currentLanguage} />
      </Container>
    </Navbar>
  );
};

export default MainNavbar;
